import { render, staticRenderFns } from "./PlanCreate.vue?vue&type=template&id=1f3465a6&scoped=true&"
import script from "./PlanCreate.vue?vue&type=script&lang=js&"
export * from "./PlanCreate.vue?vue&type=script&lang=js&"
import style0 from "./PlanCreate.vue?vue&type=style&index=0&id=1f3465a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3465a6",
  null
  
)

component.options.__file = "PlanCreate.vue"
export default component.exports